import { Tooltip } from '@mui/material';
import DesktopWindowsOutlined from '@mui/icons-material/DesktopWindowsOutlined';
import SmartphoneOutlined from '@mui/icons-material/SmartphoneOutlined';
import HelpOutline from '@mui/icons-material/HelpOutlineOutlined';
import type { FakesSearchProfile } from '../../../api/src/fakes/fakes-matrix.types';
import { Box } from './mui-system';
import { SourceIcon } from './SourceIcon';
import { searchProviderLabel } from '../../../api/src/search/search-provider.types';

export function SerpGroupLabel({
  name,
  profile,
}: {
  name: string;
  profile: FakesSearchProfile | null;
}) {
  const label = profile
    ? `${profile.searchEngine === 'google' ? 'Google' : 'Яндекс'} · ${profile.device === 'mobile' ? 'Мобильный' : 'Десктоп'} · ${profile.regionName} · ${searchProviderLabel(profile)}`
    : 'Профиль не задан для этого среза';
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        minWidth: 0,
        maxWidth: '100%',
      }}
    >
      <Tooltip title={label} describeChild>
        <Box
          component="span"
          role="img"
          aria-label={label}
          sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}
        >
          {profile ? (
            <>
              <SourceIcon provider={profile.searchEngine} />
              {profile.device === 'mobile' ? (
                <SmartphoneOutlined sx={{ fontSize: 18, opacity: 0.75 }} />
              ) : (
                <DesktopWindowsOutlined sx={{ fontSize: 18, opacity: 0.75 }} />
              )}
            </>
          ) : (
            <HelpOutline sx={{ fontSize: 18 }} />
          )}
        </Box>
      </Tooltip>
      <Box
        component="span"
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}
      >
        {name}
      </Box>
    </Box>
  );
}
